import { types } from 'mobx-state-tree';
import { Currency, CurrencyProps } from 'models/reusable-parts/currency';
import { formatDate } from 'globals/utils';

export interface EventsFeedSingleItemProps {
  id: number;
  timestamp: number;
  eventType: string;
  amount: CurrencyProps;
  title: string;
  additionalInformation: string;
  tags: string[];
}

export const EventsFeedSingleItem = types
  .model({
    id: types.number,
    timestamp: types.number,
    eventType: types.string,
    amount: Currency,
    title: types.string,
    additionalInformation: types.string,
    tags: types.optional(types.array(types.string), []),
  })
  .views((self) => ({
    displayAmount(): string {
      const { amount } = self;
      return amount?.displayValue() || '';
    },
    displayDate(): string {
      const { timestamp } = self;
      return (timestamp && formatDate(timestamp, true)) || '';
    },
    displayTags(): string {
      const { tags } = self;
      return (tags && tags.join(', ')) || '';
    },
  }));
